export const textToClassName = (text) => {
    if (!text) {
        return ''
    }
    return text.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
};

String.prototype.interpolate = function (params) {
    return this.replace(/\$\{(\w+)\}/g, (match, p1) => {
        const value = params[p1];
        // Check if the value is a string before interpolating
        return typeof value === 'string' ? value : match;
    });
};

export const getEnvVariable = (key, isRequired = true) => {
    const actualKey = `REACT_APP_${key}`
    if (!process.env[actualKey]) {
        if (isRequired) {
            console.error(`Please configure ${actualKey} in environment`)
        }
        else {
            console.warn(`Please configure ${actualKey} in environment`)
        }
        return ''
    }
    return process.env[actualKey]
}